/**
 * Detecta ciclos en un grafo de dependencias (DFS con colores). Las dependencias hacia
 * nodos fuera del grafo se ignoran: su existencia la valida otra regla.
 *
 * @example
 * findDependencyCycles(new Map([['a', ['b']], ['b', ['a']]])) // [['a', 'b', 'a']]
 */
export function findDependencyCycles(
  dependencies: ReadonlyMap<string, readonly string[]>,
): string[][] {
  const state = new Map<string, 'visiting' | 'done'>();
  const cycles: string[][] = [];
  const stack: string[] = [];

  const visit = (id: string): void => {
    const current = state.get(id);
    if (current === 'done') return;
    if (current === 'visiting') {
      cycles.push([...stack.slice(stack.indexOf(id)), id]);
      return;
    }
    state.set(id, 'visiting');
    stack.push(id);
    for (const next of dependencies.get(id) ?? []) {
      if (dependencies.has(next)) visit(next);
    }
    stack.pop();
    state.set(id, 'done');
  };

  for (const id of dependencies.keys()) visit(id);
  return cycles;
}
